import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapLeftPanelContent from './HMapLeftPanelContent'
import HMapLeftPanelMinimizer from './HMapLeftPanelMinimizer'

const HMapLeftPanelContainer = ({ children, toggle, setToggle }) => {
  const classes = useStyles({ toggle })

  return (
    <div className={classes.root}>
      <HMapLeftPanelContent toggle={toggle}> 
        {children}
      </HMapLeftPanelContent>
      <HMapLeftPanelMinimizer toggle={toggle} setToggle={setToggle} />
    </div>
  )
}

export default React.memo(HMapLeftPanelContainer)

const useStyles = makeStyles((theme, props) => ({
  root: {
    width: (props) => (props.toggle ? '475px' : '0px'),
    height: '90%',
    position: 'absolute',
    zIndex: 10,
    left: 10,
    top: 70,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: '5px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 6px #00000029',
    transition: 'width .15s',
  }
}))
